module.exports = __webpack_public_path__ + "static/media/failed.2fce6214.png";